import React from 'lib/react';
import { PieChart } from '@mui/x-charts/PieChart';
import PropTypes from 'prop-types';
import { makeStyles } from 'lib/components';
import clsx from 'lib/clsx';

const useStyles = makeStyles(() => ({
  pieChart: {
    maxWidth: ({ width }) => `${width}px`,
    maxHeight: ({ height }) => `${height}px`,
  },
}));

function AnalyticsPieChart(props) {
  const {
    sx, slotProps, tooltip, className, height, width, children, ...rest
  } = props;

  const classes = useStyles({ width, height });

  return (
    <PieChart
      sx={{
        '& *': {
          fontFamily: 'Noto Sans',
        },
        ...sx,
      }}
      margin={{
        right: 0,
        left: 0,
        top: 0,
        bottom: 0,
      }}
      className={clsx(classes.pieChart, className)}
      slotProps={{ legend: { hidden: true }, ...slotProps }}
      height={height}
      width={width}
      {...rest}
    >
      {children}
    </PieChart>
  );
}

AnalyticsPieChart.defaultProps = {
  sx: {},
  slotProps: {},
  tooltip: {},
  className: '',
  width: 200,
  height: 200,
  // #genai Preserve the existing optional-children behavior while satisfying PropTypes linting.
  children: null,
};

AnalyticsPieChart.propTypes = {
  sx: PropTypes.shape(),
  slotProps: PropTypes.shape(),
  tooltip: PropTypes.shape(),
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  // #genai: add missing props validation for 'children' (Sonar S6774)
  children: PropTypes.node,
};

export default AnalyticsPieChart;
